import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { VcsIntegration } from "types/generated";
import { hasAdminAccess } from "utils/access";

const useCanManageVCSIntegration = (): ((integration?: VcsIntegration | null) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (integration?: VcsIntegration | null) => {
      if (!integration) {
        return false;
      }

      if (viewer?.admin) {
        return true;
      }

      return hasAdminAccess(viewer, integration.space?.id);
    },
    [viewer]
  );
};

export default useCanManageVCSIntegration;
